import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Layout from "../../components/Layout.js";
import { apiFetch } from "../../api.js";

const ExpCategoryMasterGrid = () => {
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchColor, setSearchColor] = useState("");
  const [searchType, setSearchType] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const totalPages = Math.ceil(filteredData.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);

  /*------------Styles-----------*/
  const styles = {
    pageContainer: {
      width: "100%",
      minHeight: "100vh",
      backgroundColor: "#f4f6f8",
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
      padding: "10px",
      boxSizing: "border-box",
    },
    container: {
      width: "100%",
      maxWidth: "1200px",
      padding: "15px",
      borderRadius: "8px",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
      backgroundColor: "#fff",
      boxSizing: "border-box",
    },
    header: {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "15px",
      gap: "10px",
    },
    leftHeader: {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      gap: "8px",
      flex: 1,
      minWidth: "250px",
    },
    title: { fontSize: "1.2rem", fontWeight: "bold", flexShrink: 0 },
    addButton: {
      padding: "8px 16px",
      backgroundColor: "#3a28a0ff",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      whiteSpace: "nowrap",
    },
    searchInput: {
      flex: "1",
      minWidth: "140px",
      padding: "8px",
      borderRadius: "4px",
      border: "1px solid #ccc",
    },
    searchButton: {
      padding: "8px 12px",
      backgroundColor: "#2196F3",
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      whiteSpace: "nowrap",
    },
    select: {
      padding: "8px 10px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      backgroundColor: "#fff",
      whiteSpace: "nowrap",
    },
    tableWrapper: { overflowX: "auto" },
    table: { width: "100%", borderCollapse: "collapse", minWidth: "400px" },
    th: {
      padding: "10px",
      textAlign: "centre",
      backgroundColor: "#8B1E3F",
      color: "#fff",
      border: "1px solid #ddd",
      whiteSpace: "nowrap",
      fontSize: "0.9rem",
    },
    td: {
      padding: "8px",
      border: "1px solid #ddd",
      wordWrap: "break-word",
      fontSize: "0.85rem",
    },
    actionButton: (bgColor) => ({
      padding: "6px 10px",
      marginRight: "5px",
      backgroundColor: bgColor,
      color: "#fff",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
      minWidth: "60px",
      fontSize: "0.8rem",
    }),
    pagination: {
      marginTop: "12px",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "center",
      alignItems: "center",
      gap: "10px",
      fontSize: "0.9rem",
    },
    pageBtn: {
      padding: "6px 12px",
      borderRadius: "4px",
      border: "1px solid #ccc",
      cursor: "pointer",
      background: "#f9f9f9",
      fontSize: "0.85rem",
    },
  };
  //----------Load Grid
  useEffect(() => {
    loadGrid();
  }, []);
  const loadGrid = async () => {
    try {
      const res = await apiFetch(
        "/api/exp-category/grid",
      );
      const data = await res.json();
      setGridData(data);
      setFilteredData(data);
      setCurrentPage(1);
    } catch (err) {
      console.error("Grid Load Error", err);
    }
  };
  //----------handleSearch
  const handleSearch = async () => {
    try {
      if (!searchColor.trim()) {
        loadGrid();
        return;
      }

      const res = await apiFetch(
        `/api/exp-category/search?text=${encodeURIComponent(searchColor)}`, // ✅ FIX
        {
          method: "GET",
        },
      );

      if (!res.ok) {
        const errText = await res.text();
        console.error("SEARCH ERROR:", errText);
        return;
      }

      const data = await res.json();

      setFilteredData(data);
      setCurrentPage(1);
    } catch (err) {
      console.error("Search Error", err);
    }
  };
  //----------handleDelete
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this category?",
    );
    if (!confirmDelete) return;

    try {
      const res = await apiFetch(
        "/api/exp-category/delete",
        {
          method: "POST",
          body: JSON.stringify({ unqid: id }), // ✅ FIX
        },
      );

      if (!res.ok) {
        const errText = await res.text();
        console.error("DELETE ERROR:", errText);
        alert("Delete failed");
        return;
      }

      const data = await res.json(); // ✅ FIX

      if (data.err === "0") {
        alert("Deleted successfully");
        loadGrid();
      } else {
        alert(data.msg);
      }
    } catch (err) {
      console.error("Delete Error", err);
      alert("Server error");
    }
  };
  return (
    <Layout>
      <div style={styles.pageContainer}>
        <div style={styles.container}>
          {/* Header */}
          <div style={styles.header}>
            <div style={styles.leftHeader}>
              <div style={styles.title}>Category Master</div>
              <input
                type="text"
                placeholder="Search..."
                value={searchColor}
                onChange={(e) => setSearchColor(e.target.value)}
                style={styles.searchInput}
              />
              <button style={styles.searchButton} onClick={handleSearch}>
                Search
              </button>

              <select
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrentPage(1);
                }}
                style={styles.select}
              >
                {[10, 20, 50, 100].map((size) => (
                  <option key={size} value={size}>
                    {size} / page
                  </option>
                ))}
              </select>
            </div>
            <button
              style={styles.addButton}
              onClick={() => navigate("/ExpCategoryMaster")}
            >
              Add New
            </button>
          </div>
          {/* Table */}
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Category</th>
                  <th style={styles.th}>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((row) => (
                    <tr key={row.unqid}>
                      <td style={styles.td}>{row.category}</td>
                      <td style={styles.td}>
                        <button
                          style={styles.actionButton("#4CAF50")}
                          onClick={() =>
                            navigate("/ExpCategoryMaster", {
                              state: { unqid: row.unqid },
                            })
                          }
                        >
                          Edit
                        </button>

                        <button
                          style={styles.actionButton("#f44336")}
                          onClick={() => handleDelete(row.unqid)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2} style={styles.td}>
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div style={styles.pagination}>
            <button
              style={styles.pageBtn}
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Prev
            </button>
            <span>
              Page {currentPage} of {totalPages || 1}
            </span>
            <button
              style={styles.pageBtn}
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};
export default ExpCategoryMasterGrid;
